import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ClientState, CLIENTS_STATE_NAME } from "./clients.state";


export const selectClientState = createFeatureSelector<ClientState>(CLIENTS_STATE_NAME);

export const setClient = createSelector(selectClientState, (form: ClientState) => form.clients);
